import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import PayPalButtonBase from "./PayPalButtonBase";

const avatars = [
  "https://i.pravatar.cc/150?img=1",
  "https://i.pravatar.cc/150?img=2",
  "https://i.pravatar.cc/150?img=3",
];

// Nuevo componente SuccessModal
const SuccessModal = ({ isOpen, onClose }) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/60 dark:bg-black/80" />
        </Transition.Child>

        <div className="flex min-h-full items-center justify-center p-4 sm:p-6">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="scale-95 opacity-0"
            enterTo="scale-100 opacity-100"
            leave="ease-in duration-200"
            leaveFrom="scale-100 opacity-100"
            leaveTo="scale-95 opacity-0"
          >
            <Dialog.Panel className="w-full max-w-md bg-white/95 dark:bg-gray-900/95 backdrop-blur-xl rounded-3xl p-6 sm:p-8 shadow-2xl transition-all">
              <Dialog.Title className="text-2xl font-extrabold text-center mb-6 bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 to-purple-600 dark:from-indigo-300 dark:to-purple-400">
                ¡Pago Exitoso!
              </Dialog.Title>
              <p className="text-center text-gray-600 dark:text-gray-300 mb-6">
                Puede editar la información de su nuevo perfil adquirido en el panel de editar perfil.
              </p>
              <button
                onClick={onClose}
                className="w-full py-3 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-xl font-bold text-lg hover:from-indigo-600 hover:to-purple-700 transition-all"
              >
                Aceptar
              </button>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default function AcquireProfileModal({
  isOpen,
  onClose,
  plans,
  monthsOptions,
  profilesPricing,
  currentProfileCount,
  selectedPlan,
  setSelectedPlan,
  selectedMonths,
  setSelectedMonths,
  selectedProfiles,
  setSelectedProfiles,
  getPlanPrice,
  readyToRenderPayPal,
  setReadyToRenderPayPal,
  userId,
  clientId,
  paypalError,
  setPaypalError,
  processing,
  setProcessing,
  onSuccess,
  onError,
}) {
  const exchangeRate = Number(process.env.REACT_APP_EXCHANGE_RATE) || 60;
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handlePaymentSuccess = async (orderDetails) => {
    setProcessing(true);
    try {
      // Mostrar mensaje de éxito dentro del modal
      setPaymentSuccess(true);
      setTimeout(() => {
        setPaymentSuccess(false);
        setProcessing(false);
        setShowSuccessModal(true); // Abrir el modal de éxito
      }, 2000); // Mostrar el mensaje de éxito durante 2 segundos antes de abrir el modal
      onSuccess();
    } catch (error) {
      setPaypalError("Error al procesar el pago.");
      console.error("Error procesando pago:", error);
      onError({ message: "Error al procesar el pago." });
      setProcessing(false);
    }
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    onClose();
    window.location.reload(); // Recargar la página para reflejar los nuevos perfiles
  };

  const handlePayNowClick = () => {
    setPaypalError(null);
    setReadyToRenderPayPal(true);
  };

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={() => !processing && onClose()}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/60 dark:bg-black/80" />
          </Transition.Child>

          <div className="flex min-h-full items-center justify-center p-4 sm:p-6">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="scale-95 opacity-0"
              enterTo="scale-100 opacity-100"
              leave="ease-in duration-200"
              leaveFrom="scale-100 opacity-100"
              leaveTo="scale-95 opacity-0"
            >
              <Dialog.Panel className="w-full max-w-lg sm:max-w-2xl bg-white/95 dark:bg-gray-900/95 backdrop-blur-xl rounded-3xl p-6 sm:p-8 shadow-2xl transition-all">
                <button
                  onClick={() => !processing && onClose()}
                  className="absolute top-4 right-4 text-gray-400 hover:text-indigo-500 dark:hover:text-indigo-300 text-2xl font-bold transition-transform hover:scale-125"
                >
                  ×
                </button>

                <Dialog.Title className="text-3xl sm:text-4xl font-extrabold text-center mb-8 bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 to-purple-600 dark:from-indigo-300 dark:to-purple-400">
                  Adquirir Otro Perfil
                </Dialog.Title>

                {paymentSuccess && (
                  <div className="absolute inset-0 flex items-center justify-center bg-white/80 dark:bg-gray-900/80 z-50">
                    <div className="text-center">
                      <svg
                        className="w-16 h-16 text-green-500 mx-auto mb-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <p className="text-xl font-semibold text-green-500">
                        ¡Pago completado con éxito!
                      </p>
                    </div>
                  </div>
                )}

                <section className="mb-8">
                  <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-4 text-center">
                    Selecciona tu Plan
                  </h2>
                  <div className="grid gap-6 sm:grid-cols-2">
                    {plans.map((plan) => (
                      <div
                        key={plan.id}
                        onClick={() => {
                          setSelectedPlan(plan);
                          setPaypalError(null);
                          setReadyToRenderPayPal(false);
                          setProcessing(false);
                        }}
                        className={`cursor-pointer p-6 rounded-2xl border-2 transition-all duration-300 transform hover:scale-105 ${
                          selectedPlan?.id === plan.id
                            ? "border-indigo-500 bg-gradient-to-br from-indigo-50 to-purple-50 dark:from-indigo-900/50 dark:to-purple-900/50"
                            : "border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800"
                        }`}
                      >
                        <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-4">
                          {plan.title}
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 mb-2">
                          <span className="text-2xl font-bold text-indigo-600 dark:text-indigo-400">
                            {plan.postsPerMonth}
                          </span>{" "}
                          posts por mes
                        </p>
                        <p className="text-gray-600 dark:text-gray-300 mb-2">
                          RD$ <span className="font-bold text-lg">{plan.priceDOP.toFixed(2)}</span> / mes
                        </p>
                        <p className="text-gray-600 dark:text-gray-300 mb-2">
                          USD <span className="font-bold text-lg">${(plan.priceDOP / exchangeRate).toFixed(2)}</span> / mes
                        </p>
                      </div>
                    ))}
                  </div>
                </section>

                {selectedPlan && (
                  <>
                    <section className="mb-8">
                      <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-4 text-center">
                        Duración de la Membresía
                      </h2>
                      <div className="flex justify-center gap-4 flex-wrap">
                        {monthsOptions.map((months) => (
                          <button
                            key={months}
                            onClick={() => {
                              setSelectedMonths(months);
                              setPaypalError(null);
                            }}
                            className={`px-4 py-2 rounded-full font-bold transition-all duration-300 ${
                              selectedMonths === months
                                ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white"
                                : "bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-indigo-100 dark:hover:bg-indigo-900"
                            }`}
                          >
                            {months} {months === 1 ? "Mes" : "Meses"}
                          </button>
                        ))}
                      </div>
                    </section>

                    <section className="mb-8">
                      <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-4 text-center">
                        Perfiles Adicionales (Máximo 3)
                      </h2>
                      <p className="text-center text-gray-600 dark:text-gray-300 mb-4">
                        Actualmente tienes {currentProfileCount} perfil{currentProfileCount !== 1 ? "es" : ""}.
                        {currentProfileCount >= 3 ? " No puedes agregar más perfiles." : ""}
                      </p>
                      {currentProfileCount < 3 && (
                        <div className="flex justify-center gap-6 flex-wrap">
                          {profilesPricing
                            .filter((p) => p.count + currentProfileCount <= 3)
                            .map((profile) => (
                              <div
                                key={profile.count}
                                onClick={() => {
                                  setSelectedProfiles(profile.count);
                                  setPaypalError(null);
                                }}
                                className={`cursor-pointer max-w-[120px] flex flex-col items-center p-4 rounded-xl border-2 transition ${
                                  selectedProfiles === profile.count
                                    ? "border-purple-600 bg-purple-50 dark:bg-purple-900"
                                    : "border-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
                                }`}
                              >
                                <div className="flex flex-wrap justify-center gap-2 mb-3">
                                  {Array.from({ length: profile.count }).map((_, i) => (
                                    <img
                                      key={i}
                                      src={avatars[i]}
                                      alt={`Perfil ${i + 1}`}
                                      className="w-9 h-9 rounded-full border-2 border-white dark:border-gray-900 shadow-sm"
                                    />
                                  ))}
                                </div>
                                <p className="font-semibold text-gray-900 dark:text-gray-100 mb-1">
                                  {profile.count} Perfil{profile.count > 1 ? "es" : ""}
                                </p>
                                <p className="text-gray-700 dark:text-gray-300 text-sm">
                                  USD: ${(profile.priceDOP / exchangeRate).toFixed(2)}
                                </p>
                                <p className="text-gray-700 dark:text-gray-300 text-sm">
                                  RD$: {profile.priceDOP.toFixed(2)}
                                </p>
                              </div>
                            ))}
                        </div>
                      )}
                    </section>

                    {selectedProfiles && (
                      <div className="text-center mb-8">
                        <p className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 to-purple-600 dark:from-indigo-300 dark:to-purple-400">
                          Total: ${getPlanPrice(selectedPlan, selectedMonths, selectedProfiles).usd.toFixed(2)} USD
                        </p>
                        <p className="text-lg text-gray-600 dark:text-gray-300">
                          RD$: {getPlanPrice(selectedPlan, selectedMonths, selectedProfiles).dop.toFixed(2)}
                        </p>
                      </div>
                    )}

                    {selectedPlan && selectedProfiles && (
                      <button
                        onClick={handlePayNowClick}
                        disabled={processing}
                        className="w-full py-3 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-xl font-bold text-lg hover:from-indigo-600 hover:to-purple-700 transition-all disabled:opacity-50"
                      >
                        {processing ? (
                          <span className="flex items-center justify-center gap-3">
                            <svg className="animate-spin h-6 w-6 text-white" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                            </svg>
                            Procesando...
                          </span>
                        ) : (
                          "Pagar Ahora"
                        )}
                      </button>
                    )}

                    {readyToRenderPayPal && selectedProfiles && (
                      <PayPalButtonBase
                        clientId={clientId}
                        createEndpoint="/api/renewals/create-renewal-order"
                        captureEndpoint="/api/renewals/capture-renewal-order"
                        createBody={{ amount: getPlanPrice(selectedPlan, selectedMonths, selectedProfiles).usd, months: selectedMonths, userId, planType: selectedPlan.id, profileCount: selectedProfiles }}
                        captureBody={{ userId, amount: getPlanPrice(selectedPlan, selectedMonths, selectedProfiles).usd, months: selectedMonths, planType: selectedPlan.id, profileCount: selectedProfiles }}
                        onSuccess={handlePaymentSuccess}
                        onError={onError}
                        dedupeOrders={true}
                      />
                    )}
                  </>
                )}

                {paypalError && (
                  <p className="text-center text-red-500 font-semibold text-lg mt-6 bg-red-100/50 dark:bg-red-900/50 py-2 rounded-lg">
                    {paypalError}
                  </p>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>

      <SuccessModal
        isOpen={showSuccessModal}
        onClose={handleSuccessModalClose}
      />
    </>
  );
}